export default {
  init() {

    $(document).ready(function () {

      function qs(key) {
        // eslint-disable-next-line
        key = key.replace(/[*+?^$.\[\]{}()|\\\/]/g, "\\$&"); // escape RegEx meta chars
        var match = location.search.match(new RegExp("[?&]" + key + "=([^&]+)(&|$)"));
        return match && decodeURIComponent(match[1].replace(/\+/g, " "));
      }

      //Initialize the filters on the page
      if( qs('size') ) {
        $('#size_filter option[value="' + qs('size') + '"]').attr('selected', 'selected');
      }
      if( qs('location') ) {
        $('#location_filter option[value = "' + qs('size') + '"]').attr('selected', 'selected');
      }
      if( qs('wedding') ) {
        $('#wedding_filter').attr('checked', 'checked');
      }
      if( qs('meeting') ) {
        $('#meeting_filter').attr('checked', 'checked');
      }
      if( qs('outdoor') ) {
        $('#outdoor_filter').attr('checked', 'checked');
      }
      if( qs('tailgating') ) {
        $('#tailgating_filter').attr('checked', 'checked');
      }if( qs('preferred') ) {
        $('#preferred_filter').attr('checked', 'checked');
      }

      applyFilters();


      $('.resetFilters').on('click touch', function(e) {
        $('.filters :selected, .filters :checked').each(function () {
          $(this).removeAttr("selected").removeAttr("checked");
        });
        applyFilters();
        e.preventDefault();
        return false;
      });

      function getFilters(){
        let filters = [];

        $('.filters :selected, .filters :checked').each(function(){
            if($(this).data('filter')) {
              filters.push($(this).data('filter'));
            }
        });

        return filters;
      }

      function applyFilters() {

        let filters = getFilters(),
          selector = filters.join(''),
          venues = $('.venues-list'),
          form = $("#venue_filter_form");

        venues.fadeTo(100, 0.1);

        if(filters.length>0) {
          $("#venue_filter_form").addClass('filtered');
        }else{
          $("#venue_filter_form").removeClass('filtered');
        }

        if (!selector) {
          venues.find('.venue').css('display', 'flex');
        } else {
          venues.find('.venue').hide();
          venues.find(selector).css('display', 'flex');
        }

        setTimeout(function () {
          venues.fadeTo(300, 1);
        }, 300);

        if(0 == venues.find('.venue:visible').length) {
          $('.no-matches-found').show();
        }else{
          $('.no-matches-found').hide();
        }

        //Persist filter in URL
        let searchString = '';
        let formString = form.serialize();
        let searchArray = formString.match(/[^=&?]+=[^=&?]+/g);
        if (searchArray && searchArray.length > 0) {
           searchString  = "?" + searchArray.join("&") + window.location.hash;
        }
        window.history.pushState('','', window.location.pathname + searchString );

      }

      $('.filters select, .filters input').on('change', applyFilters);
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/flexibles/hasVenuesList.js